import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';

import Icon from 'foundations/Icons/Icon';

import styles from './FilterTag.css';

class FilterTag extends Component {
  static propTypes = {
    active: PropTypes.bool,
    name: PropTypes.string.isRequired,
    customStyles: PropTypes.object,
    disable: PropTypes.bool,
    white: PropTypes.bool,
    status: PropTypes.string,
    icon: PropTypes.object,
    onClick: PropTypes.func
  };

  state = {
    isActive: null
  };

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.active && (prevState.isActive === null)) {
      return {
        isActive: true
      };
    }

    return null;
  }

  handleClick = e => {
    e.preventDefault();
    const { onClick } = this.props;
    const { isActive } = this.state;

    this.setState({ isActive: !isActive });

    onClick && onClick(e);
  }

  render () {
    const {
      name,
      customStyles,
      icon,
      status,
      disable,
      white
    } = this.props;
    const { isActive } = this.state;
    const iconClass = icon ? `icon${icon.type === 'other' ? 10 : 15}` : null;
    const cx = classnames.bind(styles);
    const classes = cx(
      'tag',
      iconClass,
      {
        status,
        active: isActive,
        white,
        disable
      }
    );

    return (
      <span
        className={classnames('tag', classes)}
        style={customStyles}
        onClick={this.handleClick}
      >
        {icon && <Icon icon={icon.name} type={icon.type} customClasses={icon.customClass} />}
        {status && <i className={styles.circle} style={{ backgroundColor: status }} />}
        {name}
      </span>
    );
  }
}

export default FilterTag;



// WEBPACK FOOTER //
// ./src/uis/elements/Tags/FiltersTag/FilterTag/FilterTag.js